import { useEffect, useState } from 'react';

export function useInitialize(fun: () => Promise<void>) {
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		initialize();
	}, []);

	async function initialize() {
		if (isLoaded) return;
		await fun();
		setIsLoaded(true);
	}

	return { isLoaded, setIsLoaded };
}
